import React, { Component } from "react";
import {
  CardHeader,
  Chip,
  Card,
  FormLabel,
  Button,
  List,
  ListItemText,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import "./css/InverterSelectorForm.css";
import NavRow from "./NavRow";
import "./css/DetailedView.css";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import SaveIcon from "@mui/icons-material/Save";
import TextField from "./TextFIeld";
export class DetailedUserDataView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //Setting this true will always show next button
      // False == Disabled is true
      showNextButton: true,
      cardTitle: "UL924 Inverters Detailed Report: " + this.props.productType,
      cabChip: this.props.cabType + " Cabinet Type",
      show: true,
    };
    this.printDocument = this.printDocument.bind(this);
  }

  handleClick() {
    this.setState({ show: !this.state.show });
  }

  getDataUri(url, cb) {
    //cb(null); //todo cors
    var image = new Image();
    console.log("Print image here");
    console.log(image);
    // document.body.appendChild(image);
    image.setAttribute("crossOrigin", "anonymous"); //getting images from external domain

    image.onload = function () {
      var canvas = document.createElement("canvas");
      canvas.width = this.naturalWidth / 2;
      canvas.height = this.naturalHeight / 2;

      //next three lines for white background in case png has a transparent background
      var ctx = canvas.getContext("2d");
      ctx.fillStyle = "#fff"; /// set white fill style
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.drawImage(
        this,
        0,
        0,
        this.naturalWidth,
        this.naturalHeight,
        0,
        0,
        canvas.width,
        canvas.height
      );

      cb(canvas.toDataURL("image/jpeg"));
    };
    //Uncomment during build NOTE TODO
    //image.src = "https://cors-anywhere.herokuapp.com/" + url;
    image.src = url;
    console.log("End of getDataURI");
  }
  printDocument() {
    //console.log("Print DOCUMENT")
    //Create all PDF Text variables here
    let inputVoltcode = this.props.data.myProductNumber.split("-")[1].charAt(0);
    let inputVolt = this.props.data.ivData.split(",")[0];
    let outputVoltCode = this.props.data.myProductNumber
      .split("-")[1]
      .split(inputVoltcode)[1];
    let outputVolt = this.props.data.ovData.split(",")[0];

    const imgsrc = this.props.opData[this.props.data.modelIndex]["Image URL"];
    console.log("imgsrc");
    //console.log(imgsrc);
    //console.log("getting main png");
    html2canvas(document.querySelector("#main")).then((canvas) => {
      console.log(canvas);
      //console.log("getting info png");
      html2canvas(document.querySelector("#info")).then((canvas2) => {
        console.log("getting options png");
        html2canvas(document.querySelector("#auxconfig")).then((auxCanvas) => {
          html2canvas(document.querySelector("#tail-options")).then(
            (canvas3) => {
              const detailImageData = canvas.toDataURL("image/png");
              const tailOptionsImage = canvas3.toDataURL("image/png");
              const auxDataImage = auxCanvas.toDataURL("image/png");

              console.log("done getting html2canvas captures");

              // Resize the topImageData to half size
              const topImageCanvas = document.createElement("canvas");
              const topImage = new Image();
              topImage.onload = () => {
                const maxWidth = 500; // Maximum width for the resized image
                const maxHeight = 500; // Maximum height for the resized image
                let width = topImage.width;
                let height = topImage.height;

                // Calculate the new dimensions maintaining the aspect ratio
                if (width > height) {
                  if (width > maxWidth) {
                    height *= maxWidth / width;
                    width = maxWidth;
                  }
                } else {
                  if (height > maxHeight) {
                    width *= maxHeight / height;
                    height = maxHeight;
                  }
                }

                topImageCanvas.width = width;
                topImageCanvas.height = height;

                const ctx = topImageCanvas.getContext("2d");
                ctx.drawImage(
                  topImage,
                  0,
                  0,
                  topImage.width,
                  topImage.height,
                  0,
                  0,
                  topImageCanvas.width,
                  topImageCanvas.height
                );
                const resizedTopImageData =
                  topImageCanvas.toDataURL("image/png");

                console.log("Top Image Width: ", topImage.width);
                console.log("Top Image Height: ", topImage.height);
                console.log("Top Image Canvas Width: ", topImageCanvas.width);
                console.log("Top Image Canvas Height: ", topImageCanvas.height);

                const pdf = new jsPDF("p", "pt", "a4", false);
                console.log("creating pdf");
                // Add the resized header image data to the top of the PDF

                this.getDataUri(imgsrc, (prodImgData) => {
                  console.log("product image data got");

                  pdf.setFillColor(255, 255, 255); // RGB color for white
                  pdf.rect(0, 80, 700, 900, "F");
                  pdf.addImage(resizedTopImageData, "PNG", 110, 450);

                  pdf.setTextColor(23, 107, 203); // RGB color for white

                  pdf.addImage(prodImgData, "PNG", 180, 160);

                  pdf.setTextColor(0, 0, 0);
                  pdf.setFontSize(20);

                  pdf.text(
                    "UL924 Inverter Detailed Report and Ordering Guide",
                    30,
                    55
                  );

                  pdf.addPage();
                  console.log("page 2 ");
                  pdf.addImage(
                    detailImageData,
                    "PNG",
                    0,
                    0,
                    600,
                    0,
                    undefined,
                    false
                  );
                  pdf.setFillColor(255, 255, 255); // RGB color for white
                  pdf.rect(0, 400, 700, 600, "F");
                  pdf.addImage(
                    auxDataImage,
                    "PNG",
                    0,
                    400,
                    600,
                    0,
                    undefined,
                    false
                  );
                  pdf.addPage();
                  console.log("page 3");
                  pdf.addImage(
                    tailOptionsImage,
                    "PNG",
                    0,
                    10,
                    600,
                    0,
                    undefined,
                    false
                  );
                  const blankImage = new Image();

                  /********************************************************* */
                  /************MINI  & MICRO POWER WAVE PDF **************** */
                  /********************************************************* */
                  //Notes text(text, x(right 0 -> ), y down 0 -> , origin is upper left corner)
                  if (
                    this.props.data.productType === "Mini Power Wave" ||
                    this.props.data.productType === "Micro Power Wave"
                  ) {
                    blankImage.src = "/selector/minipowerwave-template.png";
                    pdf.addPage(null, "portrait");
                    pdf.addImage(blankImage, "PNG", 0, 0, 595, 840);

                    //pdf.setFont("ford-normal", "bold");
                    /***** */
                    //Middle Title
                    /***** */
                    pdf.setFont("Helvetica", "bold");
                    pdf.setFontSize(26);
                    pdf.text(String(this.props.data.productType), 195, 200);
                    /***** */
                    //1 Project Name
                    /***** */
                    pdf.setFontSize(10);
                    pdf.setFont("Helvetica", "normal");
                    pdf.text(this.props.data.profileData.Project, 80, 87);
                    pdf.text(
                      String(this.props.data.profileData.Rep || ""),
                      80,
                      120
                    );
                    pdf.text(
                      String(this.props.data.profileData.EEngineer || ""),
                      330,
                      120
                    );
                    /***** */
                    //3 Model Number Code
                    /***** */
                    pdf.setFontSize(10);
                    //var myModelNumber = pdf.splitTextToSize(String(this.props.data.myProductNumber), 550)
                    pdf.text(String(this.props.data.myProductNumber), 20, 240);
                    /***** */
                    //5 Date
                    /***** */
                    const todayM = new Date();
                    pdf.text(
                      String(todayM.getMonth() + 1) +
                        "-" +
                        String(todayM.getDate()) +
                        "-" +
                        String(todayM.getFullYear()),
                      330,
                      87
                    );

                    /***** */
                    //A Product Type
                    /***** */
                    pdf.setFontSize(10);
                    /***** */
                    //Model Code Name
                    /***** */
                    pdf.text(String(this.props.data.productType), 25, 325);
                    /***** */
                    //B Power Rating
                    /***** */
                    pdf.setFontSize(10);
                    pdf.text(
                      String(this.props.data.myProductNumber.split("-")[0]) +
                        " : " +
                        String(
                          this.props.data.userOPdata[
                            this.props.data.modelIndex
                          ]["Power Rating"]
                        ) +
                        "W",
                      145,
                      325
                    );
                    /***** */
                    //C Volt Input Output Label
                    /***** */
                    pdf.setFontSize(10);
                    pdf.setFont("Helvetica", "bold");
                    pdf.text("Input:", 250, 325);
                    pdf.text("Output:", 250, 340);

                    /***** */
                    //C Volt Text
                    /***** */
                    pdf.setFontSize(8);
                    //Input Code
                    pdf.text(inputVoltcode + " -  ", 295, 325);
                    pdf.setFont("Helvetica", "Normal");
                    pdf.text(inputVolt, 300 + inputVolt.length + 10, 325);
                    //outputvolt text
                    pdf.setFontSize(8);
                    pdf.setFont("Helvetica", "bold");
                    pdf.text(outputVoltCode + " - ", 290, 340);
                    pdf.setFont("Helvetica", "Normal");
                    pdf.text(outputVolt, 300 + outputVolt.length + 12, 340);

                    //**************** D Battery Type *******************//
                    //***************************************************/
                    pdf.setFontSize(9);
                    pdf.setFont("Helvetica", "bold");
                    pdf.text(
                      this.props.data.myProductNumber.split("-")[2],
                      370,
                      310
                    );
                    pdf.setFont("Helvetica", "normal");
                    pdf.text(
                      String(
                        " : " +
                          this.props.data.batTypeData +
                          " @ " +
                          this.props.data.batBUTData
                      ),
                      385,
                      310
                    );
                    /***** */ /***** */ /***** */ /***** */
                    //E <-- Options & AUX Breaker  Special will need to draw box
                    /***** */ /***** */ /***** */ /***** */
                    //Options Data

                    pdf.setFontSize(8); // Set the font size for the text
                    //let count = 0;

                    let allOptions = Object.assign(
                      {},
                      this.props.data.optionList,
                      this.props.data.monitorOptions,
                      this.props.data.batMonList
                    );

                    let newOptionsList = {};
                    let optionsYanchor = 320;

                    Object.keys(allOptions).forEach((item) => {
                      if (allOptions[item] === false) {
                        newOptionsList[item] = false;
                      }
                    });
                    Object.keys(allOptions).forEach((item, index) => {
                      if (
                        // Your condition here
                        this.props.data.optionList[item] === false ||
                        this.props.data.monitorOptions[item] === false ||
                        this.props.data.batteryList[item] === false ||
                        this.props.data.systemTransfer[item] === false ||
                        this.props.data.batMonList[item] === false ||
                        this.props.data.globMonList[item] === false
                      ) {
                        let text = item;
                        if (
                          item ===
                            "Load Control Relay, Single Flex Stud Mounting" ||
                          item === "Load Control Relay, No Flex Stud Mounting"
                        ) {
                          text += ` (${
                            this.props.data.qtyMonOption["QUANT* " + item]
                          })`;
                        }

                        let modelNumberCode = String(
                          this.props.data.modelNumberCode[String(item)]
                        );

                        // Calculate the y position for the current item
                        let yPosition = optionsYanchor; // Adjust index multiplier as needed for initial spacing

                        // First, print the model number in bold
                        pdf.setFont(undefined, "bold");
                        pdf.text(modelNumberCode, 365, yPosition);

                        // Measure the model number text width to calculate the starting point for the rest of the text
                        let modelNumberWidth =
                          (pdf.getStringUnitWidth(modelNumberCode) *
                            pdf.internal.getFontSize()) /
                          pdf.internal.scaleFactor;

                        // Set font back to normal for the item text
                        pdf.setFont(undefined, "normal");

                        // Determine starting x for the regular text, ensuring it immediately follows the bold text
                        let regularTextStartX = 365 + modelNumberWidth;

                        // Split the rest of the text to fit the line, considering starting after the model number
                        let restOfText = pdf.splitTextToSize(
                          text,
                          100 - modelNumberWidth
                        ); // Adjust width as necessary

                        // Print the rest of the text, starting immediately after the model number
                        restOfText.forEach((line, lineIndex) => {
                          // Only adjust yPosition for lines after the first
                          if (lineIndex === 0) {
                            pdf.text(
                              " : " + line,
                              regularTextStartX,
                              yPosition
                            );
                          } else {
                            if (restOfText.length === 2) {
                              yPosition += 9; // Adjust for line height
                            }
                            if (restOfText.length === 3) {
                              yPosition += 9;
                            }
                            if (restOfText.length === 4) {
                              yPosition += 10;
                            }
                            if (restOfText.length > 4) {
                              yPosition += 12;
                            }

                            pdf.text(line, 370, yPosition); // Reset X to initial value for new lines
                          }
                        });

                        // Update optionsYanchor for the next item, adjusting based on the actual number of lines printed
                        optionsYanchor = yPosition + 10; // Adjust as necessary for spacing between items
                      }
                    });

                    let auxBreakerYAnchor = 400;
                    //const auxBreakerYSize = 400;

                    if (this.props.data.auxBreakerConfig.length > 0) {
                      pdf.setFont("Helvetica", "bold");
                      pdf.setFontSize(12);
                      pdf.text("Aux Breaker", 202, 380);

                      pdf.line(200, 400, 310, 400);
                      pdf.setFontSize(9);
                      pdf.text("Standard: 10 Amp", 210, 395);
                      pdf.setFont("Helvetica", "normal");

                      pdf.rect(
                        200,
                        382, //auxBreakerYAnchor + auxBreakerYSize * this.props.data.auxBreakerConfig.length,
                        110,
                        50 + this.props.data.auxBreakerConfig.length * 50
                      );

                      for (
                        var i = 0;
                        i < this.props.data.auxBreakerConfig.length;
                        i++
                      ) {
                        pdf.setFontSize(9);

                        pdf.text(
                          "Breakers set: " + (i + 1),
                          202,
                          auxBreakerYAnchor + (i + 1) * 10
                        );

                        pdf.text(
                          "Number of Breakers: " +
                            this.props.data.auxBreakerConfig[i]["Num"],
                          202,
                          auxBreakerYAnchor + (10 + (i + 1) * 10)
                        );
                        pdf.setFontSize(6);
                        pdf.text(
                          "Output Type: " +
                            this.props.data.auxBreakerConfig[i]["O"],
                          202,
                          auxBreakerYAnchor + (20 + (i + 1) * 10)
                        );
                        pdf.setFontSize(9);
                        {
                          this.props.data.productType !== "Micro Power Wave" &&
                            pdf.text(
                              "Voltage: " +
                                this.props.data.auxBreakerConfig[i]["V"],
                              202,
                              auxBreakerYAnchor + (30 + (i + 1) * 10)
                            );
                        }

                        pdf.line(
                          200,
                          auxBreakerYAnchor + (i + 1) * 43,
                          310,
                          auxBreakerYAnchor + (i + 1) * 43
                        );

                        auxBreakerYAnchor += 40;
                      }
                    }

                    pdf.setFontSize(7);

                    let newWarrantyData = {};

                    Object.keys(this.props.data.warrantyList).map((item) => {
                      if (this.props.data.warrantyList[item] === false) {
                        newWarrantyData[item] = false;
                      }
                    });

                    //Warranty PDF TEXT
                    var initialY = 320;
                    Object.keys(newWarrantyData).map((item, index) => {
                      if (this.props.data.warrantyList[item] === false) {
                        // Prepare the text parts
                        var modelNumber =
                          this.props.data.modelNumberCode[String(item)];
                        var itemText = " : " + item; // The text that will not be bold

                        // Calculate the initial position for the text
                        initialY += index * 6;

                        // Set the bold font for the model number part
                        pdf.setFont("Helvetica", "bold"); // Setting font to bold for model number

                        // Measure the width of the bold part
                        var boldTextWidth =
                          (pdf.getStringUnitWidth(modelNumber) *
                            pdf.internal.getFontSize()) /
                          pdf.internal.scaleFactor;

                        // Print the model number in bold
                        pdf.text(modelNumber, 490, initialY);

                        // Split the rest of the text considering its length and the space available
                        var lines = pdf.splitTextToSize(itemText, 85); // Split the regular text

                        // Set the font back to normal for the rest of the text
                        pdf.setFont("Helvetica", "normal"); // Setting font back to normal

                        //pdf.text(lines, 475, 320 + index * 25);

                        let increaseMultiline = 0;

                        lines.forEach((line, lineIndex) => {
                          // Print each line of the regular text; adjust Y position based on the line index

                          pdf.text(
                            line,
                            490 + boldTextWidth,
                            initialY + increaseMultiline + lineIndex * 10
                          ); // Adjust Y for subsequent lines if needed
                        });

                        if (lines.length === 2) {
                          initialY += 15;
                        }

                        if (lines.length === 3) {
                          initialY += 25;
                        }
                        if (lines.length === 4) {
                          initialY += 30;
                        }
                        if (lines.length > 4) {
                          initialY += 48;
                        }
                      }
                    });

                    /**********************************************End of mini and micro pdf */
                  } else {
                    /*********************************************************************************** */
                    /***************************** START OF POWER WAVE PDF ***************************** */
                    /*********************************************************************************** */
                    pdf.setFontSize(16);
                    pdf.addFont("Ford-Normal.ttf", "Ford-Normal", "normal");
                    pdf.addFont("Ford-Bold.ttf", "Ford-Bold", "bold");
                    blankImage.src = "/selector/powerwave-template.png";
                    pdf.addPage(null, "landscape");
                    //Add template image.
                    //pdf.setFont("Ford-Normal", "normal");
                    /***** */
                    //Middle Title
                    /***** */
                    //pdf.setFont("Ford-Bold", "bold");
                    pdf.addImage(blankImage, "PNG", 0, 0, 840, 595);
                    //Middle Title

                    let x = 0;
                    let y = 0;
                    let fontsize = 0;
                    if (this.props.data.productType === "Power Wave 1 OSHPD") {
                      x = 290;
                      y = 90;
                      fontsize = 25;
                    } else if (this.props.data.productType === "Power Wave 1") {
                      x = 343;
                      y = 90;
                      fontsize = 25;
                    } else if (this.props.data.productType === "Power Wave 3") {
                      x = 340;
                      y = 90;
                      fontsize = 25;
                    } else if (this.props.data.productType === "Power Wave 4") {
                      x = 340;
                      y = 90;
                      fontsize = 25;
                    } else if (
                      this.props.data.productType ===
                      "Power Wave 4 Shaker Table Tested"
                    ) {
                      x = 245;
                      y = 90;
                      fontsize = 22;
                    } else if (
                      this.props.data.productType === "Power Wave 3 OSHPD"
                    ) {
                      x = 310;
                      y = 90;
                      fontsize = 22;
                    } else if (this.props.data.productType === "HE UPS") {
                      x = 365;
                      y = 90;
                      fontsize = 25;
                    }
                    pdf.setFontSize(fontsize);
                    //pdf.setFont("Ford-Normal", "normal")
                    //pdf.setFont("Symbol-Bold");
                    pdf.text(String(this.props.data.productType), x, y);
                    pdf.setFontSize(15);
                    //1 Project Name //Notes text(text, x(right 0 -> ), y down 0 -> , origin is upper left corner)
                    pdf.text(String(this.props.data.profileData.Rep), 50, 100);
                    pdf.text(
                      String(this.props.data.profileData.Project),
                      50,
                      70
                    );
                    pdf.text(
                      String(this.props.data.profileData.EEngineer),
                      640,
                      70
                    );
                    pdf.setFontSize(8);
                    let textlinePN = pdf.splitTextToSize(
                      String(this.props.data.myProductNumber),
                      800
                    );
                    pdf.text(textlinePN, 20, 128);
                    //5 Date
                    const today = new Date();

                    pdf.setFontSize(18);
                    pdf.text(
                      String(today.getMonth() + 1) +
                        "-" +
                        String(today.getDate()) +
                        "-" +
                        String(today.getFullYear()),
                      640,
                      100
                    );
                    pdf.setFontSize(8);
                    //Model Code Name
                    let modelLine = pdf.splitTextToSize(
                      String(this.props.data.productType),
                      50
                    );
                    pdf.text(modelLine, 25, 200);

                    //B Power Rating
                    //Power Rating Text
                    pdf.setFontSize(10);
                    pdf.text(
                      String(this.props.data.myProductNumber.split("-")[0]) +
                        " : " +
                        String(
                          this.props.data.userOPdata[
                            this.props.data.modelIndex
                          ]["Power Rating"]
                        ) +
                        "W",
                      90,
                      200
                    );

                    /***** */
                    //C Volt Input Output Label
                    /***** */
                    pdf.setFontSize(10);
                    //pdf.setFont("Ford-Normal", "bold");
                    pdf.setFont("Helvetica", "bold");

                    pdf.text("Input:", 165, 200);
                    pdf.text("Output:", 165, 215);
                    /***** */
                    //C Volt Text
                    /***** */
                    pdf.setFontSize(8);
                    //Input Code
                    pdf.text(inputVoltcode + " -  ", 205, 200);
                    pdf.setFont("Helvetica", "normal");
                    pdf.text(inputVolt, 205 + inputVolt.length + 10, 200);
                    //outputvolt text
                    pdf.setFontSize(8);
                    pdf.setFont("Helvetica", "bold");
                    pdf.text(outputVoltCode + " - ", 205, 215);
                    pdf.setFont(undefined, "normal");
                    pdf.text(
                      outputVolt,
                      205 +
                        (outputVolt.length > 5 ? outputVolt.length + 10 : 20),
                      215
                    );
                    //D Battery Type
                    pdf.setFontSize(9);
                    pdf.setFont(undefined, "normal");
                    pdf.text(
                      String(
                        this.props.data.myProductNumber.split("-")[2] +
                          " : " +
                          this.props.data.batTypeData +
                          " @ " +
                          this.props.data.batBUTData
                      ),
                      305,
                      200
                    );

                    //E <-- AUX Breaker  Special will need to draw box
                    const auxBreakerYAnchor = 200;
                    const auxBreakerYSize = 55;
                    {
                      this.props.data.auxBreakerConfig.length > 0 &&
                        pdf.rect(
                          417,
                          200,
                          110,
                          70 * this.props.data.auxBreakerConfig.length
                        );

                      for (
                        var i = 0;
                        i < this.props.data.auxBreakerConfig.length;
                        i++
                      ) {
                        pdf.text(
                          "Breakers set " + (i + 1),
                          420,
                          auxBreakerYAnchor + auxBreakerYSize * i * 1.2 + 10
                        );
                        pdf.text(
                          "Number of Breakers: " +
                            this.props.data.auxBreakerConfig[i]["Num"],
                          420,
                          auxBreakerYAnchor + auxBreakerYSize * i * 1.2 + 19
                        );
                        pdf.text(
                          "Amps: " + this.props.data.auxBreakerConfig[i]["A"],
                          420,
                          auxBreakerYAnchor + auxBreakerYSize * i * 1.2 + 27
                        );

                        pdf.text(
                          "Volts: " + this.props.data.auxBreakerConfig[i]["V"],
                          420,
                          auxBreakerYAnchor + auxBreakerYSize * i * 1.2 + 36
                        );

                        pdf.text(
                          "Output Type: " +
                            this.props.data.auxBreakerConfig[i]["O"],
                          420,
                          auxBreakerYAnchor + auxBreakerYSize * i * 1.2 + 44
                        );

                        if (
                          i === 1 ||
                          this.props.data.auxBreakerConfig.length === 1
                        ) {
                          pdf.text(
                            "SFB1: " + this.props.data.sfb1,
                            420,
                            auxBreakerYAnchor + auxBreakerYSize * i * 1.2 + 54
                          );
                          pdf.text(
                            "SFB2: " + this.props.data.sfb2,
                            420,
                            auxBreakerYAnchor + auxBreakerYSize * i * 1.2 + 65
                          );
                        }
                      }
                    }

                    /*************************************** */
                    /****** OPTIONS DATA PRINT TO PDF******** */

                    //Options X and Y
                    let optionsYanchor = 195;

                    //Combine all options data into one array.
                    let allOptions = Object.assign(
                      {},
                      this.props.data.optionList,
                      this.props.data.monitorOptions,
                      this.props.data.batteryList,
                      this.props.data.batMonList,
                      this.props.data.systemTransfer,
                      this.props.data.globMonList
                    );

                    //G warranty
                    //Warranty Text
                    if (Object.keys(allOptions).length > 17) {
                      console.log("17 >", Object.keys(allOptions).length);
                      pdf.setFontSize(8);
                    }

                    //let optionsYanchor = 200; // Initial y-anchor for options, adjust as needed
                    Object.keys(allOptions).forEach((item, index) => {
                      if (
                        // Your condition here
                        this.props.data.optionList[item] === false ||
                        this.props.data.monitorOptions[item] === false ||
                        this.props.data.batteryList[item] === false ||
                        this.props.data.systemTransfer[item] === false ||
                        this.props.data.batMonList[item] === false ||
                        this.props.data.globMonList[item] === false
                      ) {
                        let text = item;
                        if (
                          item ===
                            "Load Control Relay, Single Flex Stud Mounting" ||
                          item === "Load Control Relay, No Flex Stud Mounting"
                        ) {
                          text += ` (${
                            this.props.data.qtyMonOption["QUANT* " + item]
                          })`;
                        }

                        let modelNumberCode = String(
                          this.props.data.modelNumberCode[String(item)]
                        );

                        // Calculate the y position for the current item
                        let yPosition = optionsYanchor; // Adjust index multiplier as needed for initial spacing

                        // First, print the model number in bold
                        pdf.setFont(undefined, "bold");
                        pdf.text(modelNumberCode, 565, yPosition);

                        // Measure the model number text width to calculate the starting point for the rest of the text
                        let modelNumberWidth =
                          (pdf.getStringUnitWidth(modelNumberCode) *
                            pdf.internal.getFontSize()) /
                          pdf.internal.scaleFactor;

                        // Set font back to normal for the item text
                        pdf.setFont(undefined, "normal");

                        // Determine starting x for the regular text, ensuring it immediately follows the bold text
                        let regularTextStartX = 565 + modelNumberWidth;

                        // Split the rest of the text to fit the line, considering starting after the model number
                        let restOfText = pdf.splitTextToSize(
                          text,
                          150 - modelNumberWidth
                        ); // Adjust width as necessary

                        // Print the rest of the text, starting immediately after the model number
                        restOfText.forEach((line, lineIndex) => {
                          // Only adjust yPosition for lines after the first
                          if (lineIndex === 0) {
                            pdf.text(
                              " : " + line,
                              regularTextStartX,
                              yPosition
                            );
                          } else {
                            if (restOfText.length === 2) {
                              yPosition += 9; // Adjust for line height
                            }
                            if (restOfText.length === 3) {
                              yPosition += 9;
                            }
                            if (restOfText.length === 4) {
                              yPosition += 10;
                            }
                            if (restOfText.length > 4) {
                              yPosition += 12;
                            }

                            pdf.text(line, 570, yPosition); // Reset X to initial value for new lines
                          }
                        });

                        // Update optionsYanchor for the next item, adjusting based on the actual number of lines printed
                        optionsYanchor = yPosition + 10; // Adjust as necessary for spacing between items
                      }
                    });

                    /************************WARRANTY DATA******************************** */
                    let newWarrantyData = {};

                    pdf.setFontSize(9);

                    Object.keys(this.props.data.warrantyList).map((item) => {
                      if (this.props.data.warrantyList[item] === false) {
                        newWarrantyData[item] = false;
                      }
                    });
                    var initialY = 200;
                    //Warranty Text
                    Object.keys(newWarrantyData).map((item, index) => {
                      if (this.props.data.warrantyList[item] === false) {
                        // Prepare the text parts
                        var modelNumber =
                          this.props.data.modelNumberCode[String(item)];
                        var itemText = " : " + item; // The text that will not be bold

                        // Calculate the initial position for the text
                        initialY += index * 6;

                        // Set the bold font for the model number part
                        pdf.setFont(undefined, "bold"); // Setting font to bold for model number

                        // Measure the width of the bold part
                        var boldTextWidth =
                          (pdf.getStringUnitWidth(modelNumber) *
                            pdf.internal.getFontSize()) /
                          pdf.internal.scaleFactor;

                        // Print the model number in bold
                        pdf.text(modelNumber, 725, initialY);

                        // Split the rest of the text considering its length and the space available
                        var lines = pdf.splitTextToSize(itemText, 85); // Split the regular text

                        // Set the font back to normal for the rest of the text
                        pdf.setFont(undefined, "normal"); // Setting font back to normal

                        let increaseMultiline = 0;

                        lines.forEach((line, lineIndex) => {
                          // Print each line of the regular text; adjust Y position based on the line index

                          pdf.text(
                            line,
                            725 + boldTextWidth,
                            initialY + increaseMultiline + lineIndex * 10
                          ); // Adjust Y for subsequent lines if needed
                        });

                        if (lines.length === 3) {
                          initialY += 25;
                        }
                        if (lines.length === 4) {
                          initialY += 30;
                        }
                        if (lines.length > 4 && lines.length <= 6) {
                          initialY += 48;
                        }
                        if (lines.length >= 7) {
                          initialY += 58;
                        }
                      }
                    });
                  }

                  pdf.save("OnlinePower_UL924.pdf");
                  const pdfData = pdf.output("blob");
                  const formData = new FormData();

                  formData.append("pdf", pdfData);
                  formData.append("Email", this.props.data.profileData.Email);
                  formData.append(
                    "FullName",
                    this.props.data.profileData.FullName
                  );
                  // doc.save("pdf.pdf")
                  console.log("Start Fetch");
                  fetch(
                    "https://olp-email-27423c60e406.herokuapp.com/send-pdf2?to=" +
                      //"http://localhost:4000/send-pdf2?to=" +
                      this.props.data.profileData.Email,
                    {
                      method: "POST",
                      body: formData,
                    }
                  )
                    .then((response) => {
                      //response.json();
                      console.log("Response here");
                    })
                    .then((data) => console.log(data))
                    .catch((error) => console.error(error));
                  blankImage.src = "/selector/powerwave_blank.png";
                  console.log("end of blankImage");
                });
              };
              topImage.src = canvas2.toDataURL("image/png");
              console.log("topImage end");
            }
          );
        });
      });
    });
  }
  getChips(optiondata) {
    const ret = Object.keys(optiondata)
      .map((value, index) => {
        if (!optiondata[value])
          return (
            <>
              <List>
                <div
                  style={{
                    padding: "0px",
                    paddingLeft: "20px",
                    paddingRight: "20px", // Reduced padding
                    width: "100%",
                    height: "auto",
                    boxSizing: "border-box", // Include padding and border in width and height
                  }}
                >
                  <ListItemText
                    sx={{
                      display: "inline-flex",
                      minWidth: 0,
                      maxWidth: "100%", // Adjusted maxWidth to ensure it doesn't overflow
                      width: "100%",
                      textAlign: "start",
                      overflow: "hidden", // Prevent text from spilling over
                      textOverflow: "ellipsis", // Add ellipsis if text is too long
                      whiteSpace: "wrap", // Prevent words from wrapping to next line
                      fontSize: "10px",
                    }}
                    primary={"• " + value}
                  />
                </div>
              </List>
              <br />
            </>
          );
      })
      .filter((val) => val);

    if (ret.length) return ret;
    else return <div></div>;
  }

  getChipsNoWrap(optiondata) {
    const ret = Object.keys(optiondata)
      .map((value, index) => {
        if (!optiondata[value])
          return (
            <>
              <List>
                <div
                  style={{
                    padding: "0px",
                    paddingLeft: "20px",
                    paddingRight: "20px", // Reduced padding
                    width: "100%",
                    height: "auto",
                    boxSizing: "border-box", // Include padding and border in width and height
                  }}
                >
                  <ListItemText
                    sx={{
                      display: "inline-flex",
                      minWidth: 0,
                      maxWidth: "100%", // Adjusted maxWidth to ensure it doesn't overflow
                      width: "100%",
                      textAlign: "start",
                      overflow: "hidden", // Prevent text from spilling over
                      textOverflow: "ellipsis", // Add ellipsis if text is too long
                      //whiteSpace: "wrap", // Prevent words from wrapping to next line
                      fontSize: "10px",
                    }}
                    primary={"• " + value}
                  />
                </div>
              </List>
              <br />
            </>
          );
      })
      .filter((val) => val);

    if (ret.length) return ret;
    else return <div></div>;
  }

  getAuxBreakerConfig(optiondata) {
    return (
      <Paper
        id="auxconfig"
        elevation={0}
        sx={{
          padding: 2,
          maxWidth: "100%",
          "& .MuiTypography-root": { fontFamily: "Ford-Normal" },
          paddingTop: 8,
        }}
      >
        {this.props.data.auxBreakerConfig.length > 0 && (
          <CardHeader
            titleTypographyProps={{
              fontFamily: "Ford-Normal",
            }}
            title={"Aux Breaker Configuration"}
            align="Left"
            sx={{ backgroundColor: "#0d52ae", color: "#fff" }}
          />
        )}
        <Grid container spacing={2}>
          {optiondata.map((config, index) => (
            <React.Fragment key={index}>
              <Grid item xs={11} sx={{ mt: 2 }}>
                <Typography variant="h6" gutterBottom align="Left">
                  Configuration {index + 1}.
                </Typography>
              </Grid>
              <Grid
                container
                item
                spacing={1}
                alignItems="center"
                justifyContent="flex-start"
              >
                <Grid item xs={11} sm={6} md={3} lg={2}>
                  <Typography variant="body2" noWrap>
                    <strong>Breakers:</strong> {config.Num}
                  </Typography>
                </Grid>
                <Grid item xs={11} sm={6} md={3} lg={3}>
                  {this.props.data.productType !== "Micro Power Wave" && (
                    <Typography variant="body2" noWrap>
                      <strong>Voltage: </strong> {config["V"]}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={11} sm={6} md={3} lg={4}>
                  <Typography variant="body2" noWrap>
                    <strong>Type:</strong> {config.O}
                  </Typography>
                </Grid>
                <Grid item xs={11} sm={6} md={3} lg={2}>
                  <Typography variant="body2" noWrap>
                    <strong>Amps:</strong> {config.A}
                  </Typography>
                </Grid>
                <Grid item xs={11} sm={6} md={3} lg={3}>
                  <Typography variant="body2" noWrap>
                    <strong>Model Code:</strong>{" "}
                    {this.props.data.modelNumberCode[
                      String(this.props.data.auxBreakerConfig[index]["O"])
                    ] +
                      "0" +
                      this.props.data.auxBreakerConfig[index]["Num"] +
                      (this.props.data.productType !== "Micro Power Wave"
                        ? this.props.data.modelNumberCode[
                            String(
                              this.props.data.auxBreakerConfig[index]["V"]
                            ) +
                              (this.props.data.productType === "Mini Power Wave"
                                ? " AUX"
                                : "")
                          ] +
                          "-" +
                          this.props.data.auxBreakerConfig[index]["A"]
                        : "")}
                  </Typography>
                </Grid>
              </Grid>
              {this.props.data.productType !== "Micro Power Wave" && (
                <>
                  {index === this.props.data.auxBreakerConfig.length - 1 && (
                    <Grid item xs={10} sm={6} md={4} lg={5}>
                      <Typography variant="body2" noWrap>
                        <strong>Sub Feed Breaker 1:</strong>{" "}
                        {this.props.data.sfb1}
                      </Typography>
                    </Grid>
                  )}
                  {index === this.props.data.auxBreakerConfig.length - 1 && (
                    <Grid item xs={10} sm={6} md={4} lg={5}>
                      <Typography variant="body2" noWrap>
                        <strong>Sub Feed Breaker 2:</strong>{" "}
                        {this.props.data.sfb2}
                      </Typography>
                    </Grid>
                  )}
                </>
              )}
            </React.Fragment>
          ))}
        </Grid>
      </Paper>
    );
  }

  render() {
    console.log("Rendering DetailedUserDataView");
    function zoomOutMobile() {
      var viewport = document.querySelector('meta[name="viewport"]');

      if (viewport) {
        viewport.content = "initial-scale=0.1";
        viewport.content = "width=800";
      }
    }
    zoomOutMobile();
    const { cardTitle } = this.state;

    this.getChips(this.props.data.optionList);
    return (
      //App starts here

      <Card
        style={{ minWidth: "210mm", maxWidth: "210mm", minHeight: "297mm" }}
        sx={{ "& .MuiTypography-root": { fontFamily: "Ford-Normal" } }}
      >
        {
          <div>
            <CardHeader
              titleTypographyProps={{
                fontFamily: "ford-normal",
              }}
              id="main-header"
              // id="header"
              className="paperh-title"
              //fontSize={40}
              title={cardTitle}
              subheader="Note: You can submit this report to our Sales team and download a copy of the detailed report."
            />

            <TextField
              InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
              sx={{
                m: 1,
                width: "98%",
                "& input": { fontFamily: "Ford-Normal" },
              }}
              id="outlined-search"
              label="Project Name"
              value={this.props.data.profileData.Project}
              variant="filled"
            ></TextField>
            <div className="flexRow">
              <TextField
                InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
                sx={{
                  m: 1,
                  width: "45%",
                  "& input": { fontFamily: "Ford-Normal" },
                }}
                id="outlined-search"
                label="Electrical Engineer"
                value={this.props.data.profileData.EEngineer}
                variant="filled"
              ></TextField>

              <TextField
                InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
                sx={{
                  m: 1,
                  width: "48%",
                  "& input": { fontFamily: "Ford-Normal" },
                }}
                id="outlined-search"
                label="Email"
                value={this.props.data.profileData.Email}
                variant="filled"
              ></TextField>

              <TextField
                InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
                sx={{
                  m: 1,
                  width: "48%",
                  "& input": { fontFamily: "Ford-Normal" },
                }}
                id="outlined-search"
                label="Phone Number"
                value={this.props.data.profileData.PhoneNumber}
                variant="filled"
              ></TextField>
            </div>
          </div>
        }
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "start",
            flexWrap: "wrap",
            padding: "30px",
          }}
        >
          <img
            id="prodimg"
            src={this.props.opData[this.props.data.modelIndex]["Image URL"]}
            style={{ width: "40%", minWidth: "250px" }}
            alt=""
          />
          <div
            id="info"
            style={{
              display: "flex",
              justifyContent: "start",
              flexDirection: "column",
            }}
          >
            <h1 style={{ fontSize: "xx-large" }} className="infoText">
              {this.props.productType}
            </h1>
            <div className="infoText">
              <b>Capacity: </b>
              {
                this.props.data.userOPdata[this.props.data.modelIndex][
                  "Power Rating"
                ]
              }
              W
            </div>
            <div className="infoText">
              <b>Input: </b>
              {this.props.data.ivData}
            </div>
            <div className="infoText">
              <b>Output: </b>
              {this.props.data.ovData}
            </div>
            <div className="infoText">
              <b>Enclosure: </b>
              {this.props.cabType}
            </div>
            <div className="infoText">
              <b>Max number of Aux breakers: </b>
              {
                this.props.data.userOPdata[this.props.data.modelIndex][
                  "Aux Circuit Breakers"
                ]
              }
            </div>
          </div>
        </div>
        <Card>
          <CardHeader
            title="Download Product Document"
            titleTypographyProps={{
              fontFamily: "Ford-Normal",
            }}
            id="main-header"
            className="paperh-title"
          ></CardHeader>
          <Grid
            container
            spacing={3}
            paddingBottom={3}
            paddingInlineStart={1}
            paddingTop={2}
          >
            <Grid item>
              <Button
                variant="contained"
                sx={{ fontFamily: "Ford-Normal" }}
                href={
                  this.props.opData[this.props.data.modelIndex]["Data Sheet"]
                }
                target="_blank"
                endIcon={<PictureAsPdfIcon />}
              >
                {" "}
                Cut Sheet{" "}
              </Button>
            </Grid>
            <Grid item>
              <Button
                sx={{ fontFamily: "Ford-Normal" }}
                href={
                  this.props.opData[this.props.data.modelIndex][
                    "Technical Specs PDF"
                  ]
                }
                target="_blank"
                endIcon={<PictureAsPdfIcon />}
                variant="contained"
              >
                {" "}
                Technical Specification PDF
              </Button>
            </Grid>
            <Grid item>
              <Button
                sx={{ fontFamily: "Ford-Normal" }}
                href={
                  this.props.opData[this.props.data.modelIndex][
                    "Technical Specs WORD"
                  ]
                }
                target="_blank"
                endIcon={<SaveIcon />}
                variant="contained"
              >
                {" "}
                Technical Specification WORD
              </Button>
            </Grid>
            <Grid item>
              <Button
                sx={{ fontFamily: "Ford-Normal" }}
                href={
                  this.props.opData[this.props.data.modelIndex]["User Manual"]
                }
                target="_blank"
                endIcon={<PictureAsPdfIcon />}
                variant="contained"
              >
                {" "}
                User Manual{" "}
              </Button>
            </Grid>

            <Grid item>
              <Button
                sx={{ fontFamily: "Ford-Normal" }}
                href={
                  this.props.opData[this.props.data.modelIndex][
                    "Technical Drawings"
                  ]
                }
                target="_blank"
                endIcon={<PictureAsPdfIcon />}
                variant="contained"
              >
                {" "}
                Technical Drawings{" "}
              </Button>
            </Grid>
          </Grid>
        </Card>
        <div id="main">
          <CardHeader
            titleTypographyProps={{
              fontFamily: "ford-normal",
            }}
            id="main-header"
            // id="header"
            className="paperh-title"
            title={cardTitle}
            subheader="Note: You can submit this report to our Sales team and download a copy of the detailed report."
          />
          <div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Card
                variant="contained"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "1rem",
                }}
              >
                <Typography sx={{ fontSize: 13 }} variant="h7" component="div">
                  UL924 Product Model Number
                </Typography>
                <Typography
                  sx={{
                    backgroundColor: "#f2f2f2",
                    padding: "0.5rem",
                    borderRadius: "6px",
                    fontSize: 10,
                    width: 700
                  }}
                >
                  {this.props.myProductNumber}
                </Typography>
              </Card>

              <div className="flexRow">
                <TextField
                  id="outlined-search"
                  label="Model Series"
                  value={this.props.productType}
                  variant="filled"
                ></TextField>
                <TextField
                  InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
                  sx={{
                    m: 1,
                    width: "75%",
                    "& input": { fontFamily: "Ford-Normal" },
                  }}
                  id="outlined-search"
                  label="Phase Type"
                  value={
                    this.props.data.phaseTypeData === 1
                      ? "Single Phase"
                      : "Three Phase (8kW ~ 400kW)"
                  }
                ></TextField>
              </div>

              <div className="flexRow">
                <TextField
                  InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
                  sx={{
                    m: 1,
                    width: "75%",
                    "& input": { fontFamily: "Ford-Normal" },
                  }}
                  id="outlined-search"
                  label="Power Rating with TOL"
                  value={this.props.totalcap}
                  variant="filled"
                ></TextField>

                <TextField
                  InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
                  sx={{
                    m: 1,
                    width: "75%",
                    "& input": { fontFamily: "Ford-Normal" },
                  }}
                  id="outlined-search"
                  label="Input Voltage"
                  value={this.props.data.ivData + "V"}
                  variant="filled"
                ></TextField>
                <TextField
                  InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
                  sx={{
                    m: 1,
                    width: "75%",
                    "& input": { fontFamily: "Ford-Normal" },
                  }}
                  id="outlined-search"
                  label="Output Voltage"
                  value={this.props.data.ovData}
                  variant="filled"
                ></TextField>
              </div>

              <div className="flexRow">
                <TextField
                  InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
                  id="outlined-search"
                  label="Enclosure Type"
                  value={this.props.data.cabType}
                  variant="filled"
                ></TextField>
                <div
                  style={{
                    margin: "8px",
                    display: "flex",
                    flexDirection: "row",
                    width: "40%",
                    justifyContent: "flex-start",
                  }}
                >
                  <Chip
                    style={{
                      margin: "10px",
                      fontFamily: "Ford-Normal",
                    }}
                    label={this.state.cabChip}
                  />
                  <Chip
                    style={{
                      width: "200px",
                      margin: "10px",
                      fontFamily: "Ford-Normal",
                    }}
                    label={
                      this.props.data.shakerTable === "true"
                        ? "Shaker Table Tested"
                        : "Shaker Table not Tested"
                    }
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <TextField
                  InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
                  sx={{
                    m: 1,
                    width: "75%",
                    "& input": { fontFamily: "Ford-Normal" },
                  }}
                  id="outlined-search"
                  label="Battery Type"
                  value={this.props.data.batTypeData}
                  variant="filled"
                ></TextField>
                <TextField
                  InputLabelProps={{ style: { fontFamily: "Ford-Normal" } }} // font size of input label
                  sx={{
                    m: 1,
                    width: "75%",
                    "& input": { fontFamily: "Ford-Normal" },
                  }}
                  id="outlined-search"
                  label="Battery Backup Time"
                  value={this.props.data.batBUTData}
                  variant="filled"
                ></TextField>
              </div>

              {this.getAuxBreakerConfig(this.props.data.auxBreakerConfig)}

              <div
                id="tail-options"
                style={{ display: "flex", flexDirection: "column" }}
              >
                {this.getChips(this.props.data.optionList).length ? (
                  <FormLabel
                    style={{
                      marginLeft: "10px",
                      marginRight: "auto",
                      fontSize: "15px",
                      fontWeight: "bold",
                      paddingTop: "5px",
                      fontFamily: "Ford-Normal",
                    }}
                  >
                    Additional Options
                  </FormLabel>
                ) : (
                  ""
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    //paddingBottom: "5px",
                    lineHeight: "",
                  }}
                >
                  {this.getChips(this.props.data.optionList)}
                </div>
                {this.getChips(this.props.data.batteryList).length ? (
                  <FormLabel
                    style={{
                      marginLeft: "10px",
                      marginRight: "auto",
                      fontSize: "15px",
                      fontWeight: "bold",
                      //paddingTop: "5px",
                      fontFamily: "Ford-Normal",
                    }}
                  >
                    Battery Options
                  </FormLabel>
                ) : (
                  ""
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    //paddingBottom: "5px",
                    //flexWrap: "wrap",
                  }}
                >
                  {this.getChips(this.props.data.batteryList)}
                </div>

                {this.getChips(this.props.data.monitorOptions).length ? (
                  <FormLabel
                    style={{
                      marginLeft: "10px",
                      marginRight: "auto",
                      fontSize: "15px",
                      fontWeight: "bold",
                      //paddingTop: "5px",
                      fontFamily: "Ford-Normal",
                    }}
                  >
                    Monitoring Options
                  </FormLabel>
                ) : (
                  ""
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    //paddingBottom: "5px",
                    //flexWrap: "wrap",
                  }}
                >
                  {this.getChips(this.props.data.monitorOptions)}
                </div>
                {this.getChips(this.props.data.systemTransfer).length ? (
                  <FormLabel
                    style={{
                      marginLeft: "10px",
                      marginRight: "auto",
                      fontSize: "15px",
                      fontWeight: "bold",
                      //paddingTop: "5px",
                      fontFamily: "Ford-Normal",
                    }}
                  >
                    System Options
                  </FormLabel>
                ) : (
                  ""
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    //flexWrap: "wrap",
                    //paddingBottom: "5px",
                  }}
                >
                  {this.getChips(this.props.data.systemTransfer)}
                </div>
                {this.getChips(this.props.data.batMonList).length ? (
                  <FormLabel
                    style={{
                      marginLeft: "10px",
                      marginRight: "auto",
                      fontSize: "15px",
                      fontWeight: "bold",
                      //paddingTop: "5px",
                      fontFamily: "Ford-Normal",
                    }}
                  >
                    Battery Monitoring
                  </FormLabel>
                ) : (
                  ""
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    //paddingBottom: "5px",

                    flexWrap: "wrap",
                  }}
                >
                  {this.getChips(this.props.data.batMonList)}
                </div>
                {this.getChips(this.props.data.globMonList).length ? (
                  <FormLabel
                    style={{
                      marginLeft: "10px",
                      marginRight: "auto",
                      fontSize: "15px",
                      fontWeight: "bold",
                      //paddingTop: "5px",
                      fontFamily: "Ford-Normal",
                    }}
                  >
                    Global Monitoring
                  </FormLabel>
                ) : (
                  ""
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    //flexWrap: "wrap",
                    //paddingBottom: "5px",
                  }}
                >
                  {this.getChips(this.props.data.globMonList)}
                </div>
                {this.getChips(this.props.data.warrantyList).length ? (
                  <FormLabel
                    style={{
                      marginLeft: "10px",
                      marginRight: "auto",
                      fontSize: "15px",
                      fontWeight: "bold",
                      //paddingTop: "5px",
                      fontFamily: "Ford-Normal",
                    }}
                  >
                    Warranty Options
                  </FormLabel>
                ) : (
                  ""
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    //paddingBottom: "5px",
                    fontFamily: "Ford-Normal",
                  }}
                >
                  {this.getChips(this.props.data.warrantyList)}
                </div>
              </div>
            </div>
          </div>
        </div>
        <NavRow
          next={this.printDocument}
          previous={this.props.previous}
          showNextButton={true}
          submit
          showPrevButton={false}
          refresh
        />
      </Card>
    );
  }
}

export default DetailedUserDataView;
